import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorStateMatcher} from '@angular/material/core';
import {Router} from '@angular/router';
import {FrontDeskService} from 'src/app/services/front-desk.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-front-desk-orders',
  templateUrl: './front-desk-orders.component.html',
  styleUrls: [ './front-desk-orders.component.scss' ]
})
export class FrontDeskOrdersComponent implements OnInit {

  // 52º Congresso da SBCCV • 2026
  public congress_id = "zc14xOkyPrSHp1NrV5HU";
  public congress_name = "Simpósio dos 40 anos do BJCVS";

  public memberForm: FormGroup;

  public dataSourceProducts: MatTableDataSource<any>
  public displayedColumnsProducts: string[] = [ 'name' ];

  public hasSubscriptions: number = 0;

  public arrayMemberOrder: any[] = []
  public arrayAllProducts: any;

  public spinner: boolean;

  public alreadySubscribed: boolean = false;
  public showTicket: boolean = false;

  constructor (
    public _frontDeskService: FrontDeskService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService
  ) {

    if (!this._frontDeskService.currentMember) {
      this.router.navigate([ 'front-desk' ]);
    }

    //console.log('this._frontDeskService.currentMember.id: ' + this._frontDeskService.currentMember.id)
    this.getOrdersByMemberId(this._frontDeskService.currentMember.id)

  }

  ngOnInit () {
  }

  getOrdersByMemberId (member_id) {

    console.log("getOrdersByMemberId: " + member_id)

    this._frontDeskService.getOrdersByMemberId(member_id)
      .subscribe((result) => {

        this.arrayMemberOrder = []

        result.forEach((item: any) => {

          //console.log("getOrdersByMemberId: " + JSON.stringify(item.data()))

          let id = item.data().product_id

          if (id == this.congress_id) {

            let product_name = "";
            switch (item.data().product_id) {
              case this.congress_id:
                product_name = this.congress_name;
                break;
            }

            this.arrayMemberOrder.push({
              "product_name": product_name
            })

          }

        })

        if (this.arrayMemberOrder.length > 0) {
          console.log("JA ESTÁ INSCRITO")
          this._frontDeskService.memberOrders = this.arrayMemberOrder
          this.alreadySubscribed = true;
        } else {
          this.alreadySubscribed = false;
          this.loadCongress()
        }

      })

  }

  loadCongress () {

    this.dataSourceProducts = new MatTableDataSource([
      {
        'id': this.congress_id,
        'name': this.congress_name
      }
    ]);

  }

  getProduct (product) {

    //console.log(">> getProduct: " + product.id)

    let ordered = this.arrayMemberOrder.find((e) => {
      return e.product_id == product.id
    })

    if (ordered) {
      this.dialog.open(AlertComponent, {
        width: '450px',
        height: '270px',
        panelClass: 'custom-dialog-container',
        data: {title: "Alerta", message: this._frontDeskService.currentMember.name + "<br><br>já possui<br><br>" + ordered.product_name}
      });
    } else {
      this._frontDeskService.currentProduct = product
      this.router.navigate([ 'front-desk-products' ]);
    }

  }

  registerPresence (data, direction) {
    this.spinner = true
    if (direction) {
      data.register_type = "Entrance"
    } else {
      data.register_type = "Exit"
    }
    //console.log(JSON.stringify(data))

    /*
    this._frontDeskService.registerPresence(data)
      .subscribe((data) => {
        console.log("registerPresence result: " + JSON.stringify(data.result))
        this.spinner = false
      })
    */

  }

  printTicket () {
    //console.log(JSON.stringify(this._frontDeskService.currentMember))
    this.showTicket = true

    this.registerFrequancy()

  }

  registerFrequancy () {

    let frequency: any = {}
    frequency.activity_id = "";
    frequency.activity_name = "";
    frequency.day_id = "";
    frequency.day_name = "";
    frequency.event_id = this.congress_id;
    frequency.event_name = this.congress_name;
    frequency.member_id = this._frontDeskService.currentMember.id;
    frequency.member_name = this._frontDeskService.currentMember.name;
    frequency.member_category_id = this._frontDeskService.currentMember.subCategory.id
    frequency.member_category_name = this._frontDeskService.currentMember.subCategory.name;
    frequency.topic_id = "";
    frequency.topic_name = "";
    frequency.type = "Entrance";
    frequency.date = new Date();

    this._frontDeskService.registerFrequency(frequency)
      .then(() => {
        console.log('frequencia registrada')
      })
      .catch((err) => {
        console.log('ERRO ao registrar frequencia')
      })
  }

  gotoToten (doc) {
    this.router.navigate([ 'toten/' + doc ]);
  }

  goBack () {
    this.router.navigate([ 'front-desk-member' ]);
  }

}
